/**
 * Human-readable preview of stored chat markdown/HTML (no tags / `~~` in UI chrome).
 * Uses the same render path as messages (marked GFM + sanitize) then extracts textContent.
 */
import { marked } from 'marked';
import { sanitizeHtml } from '@utils/sanitizeHtml';

/**
 * @param {unknown} body
 * @returns {string} Plain text, single-line friendly; empty → ''
 */
export function plainTextPreviewFromChatBody(body) {
    const raw = String(body ?? '').trim();
    if (!raw) return '';
    try {
        const html = marked.parse(raw, { async: false, gfm: true, breaks: false });
        const str = typeof html === 'string' ? html : String(html ?? '');
        const safe = sanitizeHtml(str);
        if (typeof document === 'undefined') {
            return safe.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        }
        const div = document.createElement('div');
        div.innerHTML = safe;
        return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    } catch {
        return raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    }
}
